import React, { useEffect, useMemo } from 'react';

import { ViewportContextProvider } from '../../../contexts/owners-osb';
import { buildNavigationUrl, userProfileData } from '../../../components/sections/owners-osb/osb-utils';
import { OsbPathVehicleStep } from '../../../components/sections/osb-v3/osb-view-controller';
import { useHistory, useLocation } from 'react-router-dom';
import { useOSBStep, usePersonalDetailStep, useServiceStep } from '../../../hooks/owners-osb';
import AuthenticationService from '../../../services/authentication-service/authentication-service';
import { API_REQUEST_SOURCE_TYPE } from '../../../components/sections/owners-osb/osb-constant';
import ProfileService from '../../../services/profile-service/profile-service';

interface OsbMainWrapperViewProps {
children: React.ReactNode;
}

export function OsbMainWrapperView({ children }: Readonly<OsbMainWrapperViewProps>) {
    const history = useHistory();
    const { setOSBStepPayload } = useOSBStep();
    const queryParams = history.location.search;
    const authService = useMemo(() => new AuthenticationService(), []);
    const profileService = useMemo(() => new ProfileService(), []);


    const { setOSBServiceStepPayload } = useServiceStep();
    const { setOSBPersonalDetail } = usePersonalDetailStep();
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    useEffect(() => {
        history.push(buildNavigationUrl(OsbPathVehicleStep(), queryParams));
    }, []);

    const initializeAuthenticatedJourney = async () => {
        const isAuthenticated = await authService.onIsAuthenticated();

        setOSBStepPayload({
            source: authService.getwebviewBundle()?.source || API_REQUEST_SOURCE_TYPE.WEB,
        });

        if (isAuthenticated) {
            try {
                const { profile, vehicles } = await profileService.request();

                setOSBStepPayload({
                    isAuthenticatedFlow: true,
                });

                if (profile) {
                    const customerDetails = userProfileData(profile);
                    setOSBPersonalDetail(customerDetails, false);
                }

                if (vehicles && vehicles.length > 0) {
                    setOSBServiceStepPayload({
                        userVehicles: vehicles.map(({ modelName, nickName, vin, modelYear }) => ({
                            modelName,
                            nickName,
                            vin,
                            modelYear,
                        })),
                    });
                }
            } catch (error) {
                console.error('Failed to load user profile in OSB wrapper.', error);
            }
        }
    };

    useEffect(() => {
        initializeAuthenticatedJourney();
    }, []);


    return (
        <ViewportContextProvider>
            <div className="osb-main-wrapper-view">{children}</div>
        </ViewportContextProvider>
    );
}
